import ni from '../data/node-index';

let indexOptimize = {
  exeOptimize : node=>{
    let $optimize = $('.ui-node-optimize');
    if(!$optimize.length){
      $optimize = $(`<div class="ui-node-optimize ui-modal">
        <span class="modal-close">&times;</span>
        <h5>Optimize</h5>
        <form>
        <p>
          <label for="max_num_segments">Maximum # Of Segments*
          <input type="number" id="max_num_segments" name="max_num_segments" max="100" min="1" value="1"></label>
        </p>
        <p>
          <label for="only_expunge_deletes">Only Expunge Deletes
          <input type="checkbox" value="true" id="only_expunge_deletes" name="only_expunge_deletes"></label>
        </p>
        <p>
          <label for="flush">Flush After Optimize
          <input type="checkbox" value="true" id="flush" name="flush" checked></label>
        </p>
        </form>
        <button type="button">OK</button>
      </div>`);
      $optimize.find('.modal-close').click(()=>{
        $optimize.hide()
      });
      $('body').append($optimize);
    }else{
      $optimize.find('input[type=text]').val('');
      $optimize.show();
    }
    $optimize.find('button').off('click').on('click', ()=>{
      if($optimize.find('input[name=max_num_segments]').val() !== '') {
        let payload = $optimize.find('form').serialize();
        ni.optimize(node, payload);
        $optimize.hide();
      }
    });
  }
}

export default indexOptimize;


// WEBPACK FOOTER //
// ./src/scripts/ui/index-optimize.js